import { IComponentsService } from "../../interfaces/IComponentsService";
import { IComponentGameObject } from "../../interfaces/IComponentGameObject";
import { IComponent } from "../../interfaces/IComponent";
import { TableScreen } from "../screen/TableScreen";
import { Player } from "../player/Player";
import { Card } from "../card/Card";
import { TableStack } from "../cardStack/TableStack";
import { AppSettings } from "../managers/AppSettings";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { PlayerProps } from "../player/Players";
import { OptionsItemKeys } from "../managers/LayoutDataManager";
import { OptionsItemLiveData } from "../../types/types";
import { CardsManager } from "../managers/CardsManager";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { AppTimings } from "../data/AppConstants";


export class DealerTableToPlayer
    implements IComponent {
    private table!: TableScreen;
    // private components!: IComponentsService;

    public tableStack: TableStack;
    private inputData: any;
    private pickedCards: Array<Card> = [];


    public constructor(tableStack: TableStack) {
        this.tableStack = tableStack;
    }

    public Init(go: IComponentGameObject, components: IComponentsService): void {
        this.table = go as TableScreen;
        // this.components = components;

        // listen table events?
    }
    //awake(){}
    //start(){}
    //update(){}
    //destroy(){}

    // destroy()
    // {
    //     // console.log("CardStackFacing::destroy");
    // }

    public SetData(inputData: any): void {
        this.inputData = inputData;
        // console.log(TaskType[this.inputData.taskType]);
    }

    public GetData(): any {
        return this.inputData;
    }

    /**
     * 
     * @param cards 
     */
    // public Deal(playerIndex:number, count:number):void
    public Deal(): void {
        // console.log("Deal:",this.inputData)
        const animateDealingCards: OptionsItemLiveData = OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.animateDealingCards, this.table.variationId);
        const isAnimateDealingCards: boolean = animateDealingCards && (animateDealingCards.value as boolean);
        const rankLeftToRight: boolean = OptionsDataManager.IsRankLeftToRight();
        const stackLeftToRight: boolean = OptionsDataManager.IsStackLeftToRight();
        const player: Player = this.table.players.GetPlayerByIndex(this.inputData.playerIndex);
        const playerProps: PlayerProps = player.GetPlayerProps();
        const stackCardsCount = this.tableStack.GetLength();
        const pickCardsCount = Math.min(this.inputData.cardsCount, stackCardsCount);
        this.pickedCards = this.tableStack.PickCards(pickCardsCount);
        
        // for table to player dealing without animation, only animate once all cards are dropped
        if (!isAnimateDealingCards) {
            player.DropCards(this.pickedCards,
                false, // animateReorder
                this.table.GetStateMachine().GetData().trumpSuit, // trumpSuit
                rankLeftToRight, // rankLeftToRight 
                stackLeftToRight, // stackLeftToRight
                false // skipReorder
            );
            this.pickedCards = [];
            this.inputData.onComplete(this.inputData.taskType);
            return;
        }

        //
        // animateDealingCards = TRUE
        //
        
        this.pickedCards.forEach(card => {
            card.setVisible(false);
            card.SetFrontFacing(false);
            card.scale = this.tableStack.scale;
        });
        
        let dealDuration: number = OptionsDataManager.GetTiming(AppTimings.cardDealTableToPlayerDuration);
        let dealDelay: number = OptionsDataManager.GetTiming(AppTimings.cardDealTableToPlayerDelay);
        // DEBUG
        // dealDuration = 5000;
        // dealDelay = 1000;
        
        // NOTE: player.props.facing.x|y == -1 OR 1 (no other value)
        // results in random from -1,1 for target axis
        this.pickedCards.forEach((card, i) => {
            const xDeviation = playerProps.facing.x == 0 ? 0 : 0.5 - Math.random() * (Math.abs(playerProps.facing.x));
            const yDeviation = playerProps.facing.y == 0 ? 0 : 0.5 - Math.random() * (Math.abs(playerProps.facing.y));
            // console.log(xDeviation, yDeviation);
            // console.log(this.inputData.playerIndex, player.props.facing, player.props.dX,player.props.dY)

            this.table.scene.tweens.add({
                targets: card,
                duration: dealDuration,
                x: player.x - playerProps.facing.x * 200 + yDeviation * 200,
                y: player.y - playerProps.facing.y * 200 + xDeviation * 200,
                delay: i * dealDelay,
                onStart: () => {
                    card.setVisible(true);
                    this.table.cardContainer.add(card);
                    card.setPosition(card.x + this.tableStack.x, card.y + this.tableStack.y);
                    AppAudioPlayer.PlaySfxRandomFromCollection([
                        SoundEffectKeys.drawS3,
                        SoundEffectKeys.drawS4,
                        SoundEffectKeys.drawS5,
                        SoundEffectKeys.drawS6,
                        SoundEffectKeys.drawS8,
                        SoundEffectKeys.drawS9,
                        SoundEffectKeys.drawS10,
                    ]);
                },
                onStartScope: this,
                onComplete: () => {
                    // last card finished animation
                    if (i == pickCardsCount - 1) {
                        player.DropCards(this.pickedCards,
                            // isAnimateDealingCards, // animate
                            true,
                            this.table.GetStateMachine().GetData().trumpSuit, // trumpSuit
                            rankLeftToRight, // rankLeftToRight 
                            stackLeftToRight, // stackLeftToRight
                            false
                            // player.index != 2
                        );
                        this.pickedCards = [];
                        this.inputData.onComplete(this.inputData.taskType);
                    }
                },
                onCompleteScope: this,
            })
        });
    }

    /**
     * Pool picked cards (those being currently animated) and reset vars/state
     */
    public Reset(): void {
        this.pickedCards.forEach(card => {
            this.table.scene.tweens.killTweensOf(card);
            card.setVisible(true);
            card.scale = 1;
        });
        CardsManager.DropCards(this.pickedCards, false);
        this.pickedCards = [];
        // this.table.scene.time.clearPendingEvents();
        this.tableStack.visible = true;
        this.table.cardContainer.visible = true;
    }
}